import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postActionFlags, postActionFlagsClearData, } from "../../store/pageActionFlags/actions";
export var PostActionFlags = function (trigger, projectId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePostActionFlags: (_a = state.PageActionFlags.responsePostActionFlags) === null || _a === void 0 ? void 0 : _a.data,
            loadingPostActionFlags: state.PageActionFlags.loadingPostActionFlags,
            errorPostActionFlags: state.PageActionFlags.errorPostActionFlags,
        });
    }), responsePostActionFlags = _a.responsePostActionFlags, loadingPostActionFlags = _a.loadingPostActionFlags, errorPostActionFlags = _a.errorPostActionFlags;
    useEffect(function () {
        if (trigger) {
            var names = [
                "afy-plan-range-age",
                "afy-confirm-data-show-insured",
                "afy-confirm-data-add-insured",
                "afy-confirm-data-show-beneficiary",
                "afy-confirm-data-add-beneficiary",
                "afy-validate-customer-default-country",
            ];
            for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
                var name = names_1[_i];
                dispatch(postActionFlags({
                    name: name,
                    value: "false",
                    projectId: projectId,
                }));
                dispatch(postActionFlagsClearData());
            }
        }
    }, [projectId, trigger]);
    return {
        responsePostActionFlags: responsePostActionFlags,
        loadingPostActionFlags: loadingPostActionFlags,
        errorPostActionFlags: errorPostActionFlags,
    };
};
